import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setSubStage } from '../../../../slices/eligibility/eligibilitySlice';
import NoImageComponent from '../../../common/NoImage';
import ImageComponent from '../../../common/Image';
import { toTitleCaseAdvanced } from '../../../../utils/functions';
import Loader from '../../../common/Loader';

function Brands({ data: currentData, setData }) {
    const { data, loading } = useSelector(state => state?.eligibility);
    const dispatch = useDispatch();
    const [searchPopup, setSearchPopup] = useState(false)
    const [searchTerm, setSearchTerm] = useState('');

    // ...existing code...

    const setBrand = (brand) => {
        if (setData) {
            setData(prev => ({
                ...prev,
                brand: { ...brand }
            }));
        }
        dispatch(setSubStage("category"));
    };

    const filteredBrands = Array.isArray(data)
        ? data.filter(item =>
            item?.brand_name?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];

    // Function to get brand image and determine if it's a specific brand
    const getBrandImageInfo = (brandName) => {
        const name = brandName?.toLowerCase();

        switch (name) {
            case 'lg':
                return { src: 'lg.svg', isSpecificBrand: true };
            case 'haier':
                return { src: 'haier.svg', isSpecificBrand: true };
            case 'vivo':
                return { src: 'vivo.png', isSpecificBrand: true };
            case 'whirlpool':
                return { src: 'whirlpool.svg', isSpecificBrand: true };
            case 'oppo':
                return { src: 'oppo.svg', isSpecificBrand: true };
            default:
                return { src: 'no2.svg', isSpecificBrand: false };
        }
    };

    // Determine loader state: use eligibility.loading if available, else fallback to false
    const loader = typeof loading === 'boolean' ? loading : false;

    return (
        <>
            <div className="col-md-9 col-sm-12 Side-bank-Right variant-div">
                <div className="col-12 mb-1 static-tab brand-header-tab">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex gap-2 align-items-center">
                            <p className="Pname-i mb-0">
                            </p>
                            <div className="lh-0">
                                <p className="fs-14 mb-0 blue">Select Brand</p>
                            </div>
                        </div>

                        <div className="fs-3">
                            <span className="icon-searchnormal inside-search border p-1 rounded text-secondary  border-secondary fs-6"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        setSearchPopup(true)
                                    }
                                }}
                                onClick={() => {
                                    setSearchPopup(true)
                                }}></span>
                        </div>
                    </div>
                </div>
                <div className="row gy-4 mt-2 tab-brand-div">
                    {/* Only show brands or 'No Brand found' after loader is false */}
                    {loader ? null : (
                        Array.isArray(data) && data.length > 0 ? (
                            data.map((item) => {
                                const brandImageInfo = getBrandImageInfo(item?.brand_name);

                                return (
                                    <div
                                        key={item?.brand_id}
                                        className="col-6 col-lg-3 col-md-6 brand-box m-0"
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => setBrand(item)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setBrand(item);
                                            }
                                        }}
                                    >
                                        <div className="product-details prod-brand p-3 justify-content-center">
                                            <div className='text-center'>
                                                {item?.oem_image_url ? (
                                                    <img loading="lazy"
                                                        src={item.oem_image_url}
                                                        className="img-fluid brand-img"
                                                        alt={item.brand_name || "Brand"}
                                                    />
                                                ) : brandImageInfo.isSpecificBrand ? (
                                                    <ImageComponent
                                                        fileName={brandImageInfo.src}
                                                        className="img-fluid brand-img"
                                                        alt={item.brand_name || "Brand"}
                                                    />
                                                ) : (
                                                    <NoImageComponent
                                                        fileName="no2.svg"
                                                        className="img-fluid"
                                                        alt={item.brand_name || "Brand"}
                                                    />
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <h6 className="text-center">No Brand found</h6>
                        )
                    )}
                </div>
                {searchPopup &&
                    <>
                        <div
                            className="modal show fade"
                            id="searchrole"
                            style={{ display: "block" }}
                            aria-hidden="true"
                            aria-labelledby="Dealerrole"
                            tabIndex="-1"
                            onClick={() => setSearchPopup(false)}
                        >
                            <div className="modal-dialog bottom-modal">
                                <div
                                    className="modal-content blue"
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    <div className="modal-header">
                                        <div className="top-draw"></div>
                                    </div>
                                    <div
                                        className="d-flex align-items-center justify-content-between px-4"
                                    >
                                        <h6 className="mb-1">Brand Search</h6>

                                    </div>
                                    <div className="modal-body searchrole p-4" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                        <form
                                            className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 position-relative"
                                            role="search"
                                            onSubmit={(e) => e.preventDefault()}
                                        >
                                            <input
                                                type="search"
                                                className="form-control input-underline"
                                                placeholder="Search by Brand"
                                                aria-label="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            <div className="has-i-search hidden-search-box brand-search">
                                                <span className="icon-searchnormal fs-4 inside-search border-0"></span>
                                            </div>
                                        </form>

                                        <div className="row mb-3 mt-3">
                                            <div className="col-md-12 RightPane">
                                                <p className="text-secondary mb-2">Search Results</p>
                                            </div>

                                            {filteredBrands?.length > 0 ? (
                                                filteredBrands?.map((item) => {
                                                    const brandImageInfo = getBrandImageInfo(item?.brand_name);
                                                    return (
                                                        <div
                                                            key={item?.brands}
                                                            className="col-md-12 mt-2"
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={() => {
                                                                setBrand(item);
                                                                setSearchPopup(false); // optional: close modal after select
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    setBrand(item);
                                                                    setSearchPopup(false);
                                                                }
                                                            }}
                                                        >
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="fw-semibold">{(item?.brand_name || '').toUpperCase()}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="col-md-12 mt-2">
                                                    <p className="text-muted">No matching brands</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                }
            </div>
        </>
    );
}

// ✅ PropTypes validation
Brands.propTypes = {
    data: PropTypes.shape({
        product: PropTypes.string
    }).isRequired,
    setData: PropTypes.func.isRequired
};

export default Brands;
